module.exports = __webpack_public_path__ + "assets/img/10.e9f64100.png";